import { createRoot } from 'react-dom/client'
import Scene from './Scene'
import Overlay from './Overlay/Overlay'
import CustomLoader from './CustomLoader'
import './loader.css'
import Lenis from '@studio-freight/lenis'

const root = createRoot(document.getElementById('root'))

const lenis = new Lenis({
  duration: 4.5,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

root.render(
  <>
    <Scene />
    <Overlay />
    <CustomLoader />
  </>
)
